function getCookie(key) {
  if (!key) {
    return;
  }

  // To prevent the for loop in the first place assign an empty array
  // in case there are no cookies at all.
  const cookies = globalThis.document.cookie ? globalThis.document.cookie.split("; ") : [];
  const jar = {};
  for (let i = 0; i < cookies.length; i++) {
    const parts = cookies[i].split("=");
    let value = parts.slice(1).join("=");
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    try {
      const foundKey = parts[0].replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
      jar[foundKey] = value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
      if (key === foundKey) {
        break;
      }
    } catch (e) {}
  }
  return key ? jar[key] : jar;
}
function detectFromCookie(key) {
  return getCookie(key);
}
function detectFromPath(localePathIndex) {
  let location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis.location;
  const locale = location.pathname.match(/\/([a-zA-Z-]*)/g);
  if (Array.isArray(locale)) {
    return locale[localePathIndex].replace("/", "");
  }
  return null;
}
function detectFromStorage(key) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    useSessionStorage: false
  };
  if (options.useSessionStorage) {
    return globalThis.sessionStorage.getItem(key);
  }
  return globalThis.localStorage.getItem(key);
}
function detectFromNavigator() {
  let navigator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : globalThis.navigator;
  const result = navigator.language || navigator.userLanguage;
  return result;
}
function detectFromSubdomain(localeSubdomainIndex) {
  let location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis.location;
  const locale = location.href.match(/(?:http[s]*\:\/\/)*(.*?)\.(?=[^\/]*\..{2,5})/gi);
  if (Array.isArray(locale)) {
    return locale[localeSubdomainIndex].replace("http://", "").replace("https://", "").replace(".", "");
  }
  return null;
}
function detectHtmlTag(htmlTagIdentifier) {
  let document = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis.document;
  if (htmlTagIdentifier) {
    return document.documentElement.getAttribute(htmlTagIdentifier);
  }
  return null;
}

/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 */
function parse(query) {
  const parser = /([^=?#&]+)=?([^&]*)/g;
  const result = {};
  let part;
  while (part = parser.exec(query)) {
    const key = decode(part[1]);
    const value = decode(part[2]);

    //
    // Prevent overriding of existing properties. This ensures that build-in
    // methods like `toString` or __proto__ are not overriden by malicious
    // querystrings.
    //
    // In the case if failed decoding, we want to omit the key/value pairs
    // from the result.
    //
    if (key === null || value === null || key in result) continue;
    result[key] = value;
  }
  return result;
}
function decode(input) {
  try {
    return decodeURIComponent(input.replace(/\+/g, " "));
  } catch (e) {
    return null;
  }
}
function detectFromUrl(parameter) {
  let location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis.location;
  if (!parameter) throw new Error("fromUrl parameter is required");
  const result = parse(location.search)[parameter] || null;
  return result;
}
function detect() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  for (let i = 0; i < args.length; i++) {
    const res = typeof args[i] === "function" ? args[i]() : args[i];
    if (res) return res;
  }
  return null;
}
function multipleDetect() {
  const locales = [];
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  for (let i = 0; i < args.length; i++) {
    const res = typeof args[i] === "function" ? args[i]() : args[i];
    if (res) locales.push(res);
  }
  return locales;
}
export { detect, detectFromCookie as fromCookie, detectHtmlTag as fromHtmlTag, detectFromNavigator as fromNavigator, detectFromPath as fromPath, detectFromStorage as fromStorage, detectFromSubdomain as fromSubdomain, detectFromUrl as fromUrl, multipleDetect };